import React from "react";
import PropTypes from "prop-types";

import Str from "shared/components/Str";
import getImagePath from "shared/util/getImagePath";

import {
	CopyText,
	VoucherStatus,
} from "shared/components/VoucherModal/constants";

const Results = ({ voucherStatus, closeModal, onRetryVoucher }) => (
	<React.Fragment>
		{voucherStatus === VoucherStatus.SUCCESS &&
			<div className="voucherContents">
				<img className="voucherContents-openbox" src={`${getImagePath()}media/img/vouchers/Box_01.gif`} alt="voucher" />
				<Str className="voucherContents-header openbox">Success!</Str>
				<Str className="voucherContents-sub almostThere">
					Your promotion is redeemed.
				</Str>
				<button
					type="button"
					className="big blue flatbutton openbox"
					onClick={closeModal}
				>
					<Str>{CopyText.LETS_GO}</Str>
				</button>
			</div>
		}
		{voucherStatus === VoucherStatus.FAILURE &&
			<div className="voucherContents">
				<img className="voucherContents-openboxFail" src={`${getImagePath()}media/img/vouchers/emptybox.png`} alt="voucher" />
				<Str className="voucherContents-header openboxFail">
					Something went wrong
				</Str>
				<Str className="voucherContents-sub almostThere">
					This code is not valid
				</Str>
				<button
					type="button"
					className="big blue flatbutton openboxFail"
					onClick={closeModal}
				>
					<Str>Close</Str>
				</button>
				<button
					type="button"
					className="voucherContents-retry"
					onClick={onRetryVoucher}
				>
					<Str>Retry voucher</Str>
				</button>
			</div>
		}
	</React.Fragment>
);

Results.propTypes = {
	voucherStatus: PropTypes.string.isRequired,
	closeModal: PropTypes.func.isRequired,
	onRetryVoucher: PropTypes.func.isRequired,
};

export default Results;



// WEBPACK FOOTER //
// ./src/shared/components/VoucherModal/Results.jsx